import { call, fork, take, all, put } from "redux-saga/effects";
import { startLocalStorage } from './uuid'; 
import { startStopChannel, watchSendTyping, watchSendEndTyping, watchUserStatusChange, watchGetUsersStatus, watchNewMessageForStatus, } from './socket';
import { watchLauncherClick, showLauncher, initLauncher } from './launcher';
import { watchLoadMessages, watchSendMessage, watchInitWidget, watchReadMessages, watchNewMessage, watchLoadMessagesDivWidget, watchTalkToHuman, watchActionButtonClick } from './api';
import { startMessageChannel } from './messageChannel';

export default function* rootSaga() {

  yield fork(startMessageChannel);
  yield take('SET_INIT');

  yield fork(watchInitWidget);
  yield fork(startStopChannel);

  yield all([
    take('SERVER_ON'),
    take('INIT_SUCCESS')
  ]);

  yield call(initLauncher);
  yield fork(watchLauncherClick);
  yield fork(watchLoadMessagesDivWidget);
  yield fork(watchLoadMessages);
  
  yield put({ type: 'LOAD_MESSAGES_DIV_WIDGET' });

  yield fork(watchSendMessage);
  yield fork(watchSendTyping);
  yield fork(watchSendEndTyping);
  yield fork(watchReadMessages);
  yield fork(watchNewMessage);
  yield fork(watchGetUsersStatus);
  yield fork(watchUserStatusChange);
  yield fork(watchNewMessageForStatus);
  yield fork(watchTalkToHuman);
  yield fork(watchActionButtonClick);
  yield call(showLauncher);
}